import App from "./app";
import ReadMore from './classes/class-read-more';

(() => {
  const nodes = document.querySelectorAll('.js-read-more');
  if (!nodes) return false;
  const items = [...nodes].map(node => new ReadMore(node, {
    textMore: 'Показать еще',
    textLess: 'Свернуть',
  }));
  App.breakpoints.onBreakpoint(
    'xxs xs',
    () => {
      if (items) {
        items.forEach((item) => {
          if (item.enable) item.enable();
        });
      }
    },
    () => {
      if (items) {
        items.forEach((item) => {
          if (item.disable) item.disable();
        });
      }
    },
  );
  return items;
})();
